import { getDashboardAssistantNavigationTarget } from '@charitystack/dashboard-assistant-contracts';

function target(name) {
  const value = getDashboardAssistantNavigationTarget(name);
  if (!value) throw new Error(`Unknown dashboard assistant navigation target: ${name}`);
  return value;
}

export const SET_OPEN_PROFILE_SETTINGS = target('open_profile_settings');
export const SET_OPEN_BILLING_SETTINGS = target('open_billing_settings');
export const SET_OPEN_USERS_SETTINGS = target('open_users_settings');
export const SET_OPEN_PERMISSIONS_SETTINGS = target('open_permissions_settings');
export const SET_OPEN_EMBED_SETTINGS = target('open_embed_settings');
export const SET_OPEN_FAQ_SETTINGS = target('open_faq_settings');
export const SET_OPEN_CUSTOM_INPUT_SETTINGS = target('open_custom_input_settings');
export const SET_OPEN_EMAIL_SETTINGS = target('open_email_settings');
export const SET_OPEN_COMPLIANCE_SETTINGS = target('open_compliance_settings');
export const SET_OPEN_PAYOUT_FREQUENCY_SETTINGS = target('open_payout_frequency_settings');
export const SET_OPEN_INTEGRATIONS_SETTINGS = target('open_integrations_settings');
export const SET_OPEN_CONTACT_PORTAL_SETTINGS = target('open_contact_portal_settings');
